<div class="dialog-header">
  <button
    class="close-button"
    mat-icon-button
    tabindex="-1"
    cdkFocusInitial
    (click)="closeDialog(false)"
  >
    <i class="bosch-ic bosch-ic-clickable bosch-ic-close"></i>
  </button>
</div>

<div class="dialog-content flex-center-col">
  <div class="img-check">
    <img src="{{ imgPath }}" />
  </div>
  <div class="text-infos flex-center-col">
    <h3>{{ title }}</h3>
    <span [innerHTML]="description"></span>
  </div>
</div>

<div class="dialog-actions">
  <button mat-raised-button color="primary" (click)="closeDialog(false)">
    {{ buttonText }}
  </button>
</div>
